import { render, staticRenderFns } from "./PortfolioManager.vue?vue&type=template&id=03873b90&scoped=true&"
import script from "./PortfolioManager.vue?vue&type=script&lang=js&"
export * from "./PortfolioManager.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioManager.vue?vue&type=style&index=0&id=03873b90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03873b90",
  null
  
)

export default component.exports